import { JobOutput } from 'types';
import { createAction } from 'typesafe-actions';
import { JobsActionTypes } from './types';

export const updateJobFiles = createAction(JobsActionTypes.UPDATE_JOBOUTPUTS)<JobOutput[]>();
export const updateDocuments = createAction(JobsActionTypes.UPDATE_DOCUMENTS)<JobOutput[]>();
